/**
 * @module builder
 */
import type { QuoteDocument } from 'paintscout'

export function setJobIdentifier(args: { quote: QuoteDocument; identifier: string }): QuoteDocument {
  const { quote, identifier } = args
  return {
    ...quote,
    job_identifier: identifier
  }
}
